<template lang="pug">
.welfare-exchange-container
  .header
    .line-1 可用奖励金
    .bounty
      .amount {{ points }}
      .unit 个
      .hint.flex-mid 可抵{{ amount }}元
    .line-3
      span 其中
      span.tag {{ expiring }}
      span 个本月底过期
    .operation
      .btn.flex-mid(@click="goDetail") 查看明细
      .btn.flex-mid(@click="goRule") 奖励金规则
  .body
    ExchangeList(
      :bounty="amount"
      :points="points"
      :tabs="TABS"
      :popupSource=3
      :hideBonus="isHideBonus"
      @bounty="getBasic"
      @loaded="onListLoaded"
    )
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import { getVersion } from '@/utils/systemCode';
import { compareVersions, safeJsonStringify } from '@/utils/tools';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import config from '@/const/config';
import ExchangeList from '../bounty-tab/cpns/exchange-list';
import { welfareGo } from '../utils';
import { getBountyBasicInfo, bountyExchangeTab } from '../../../api/bounty';
import { getTokenAndKey, isPreRender } from '../../../utils';
import { ParamsUtil } from '../../../utils/params';

export default {
  name: 'BountyExchange',
  components: {
    ExchangeList,
  },
  provide() {
    return {
      isSupportAd: () => this.isSupportAd,
    };
  },
  data() {
    return {
      TABS: [],
      points: 0,
      amount: 0,
      expiring: 0,
      // 是否支持广告
      isSupportAd: true,
      // 是否是App端
      isApp: env.isEasyBikeApp,
      // 是否隐藏积分+现金（旧版跳转时传入）
      isHideBonus: ParamsUtil.getParam('isHideBonus') === 'true',
    };
  },
  async created() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      // eslint-disable-next-line no-useless-return
      return;
    }
    this.judgePageAdSupport();
    await this.getTabs();
  },
  async mounted() {
    UBT.moduleExpose({
      pageId: 'platform_My_reward_points',
      categoryId: 'platform',
      moduleId: 'platform_myrewardpoint_exchange',
      contentId: 'platform_myrewardpoint_exchange',
      exposureTimes: 1,
      businessInfo: {},
    });

    UBT.moduleExpose({
      pageId: 'platform_My_reward_points',
      categoryId: 'platform',
      moduleId: 'platform_Myrewardpoints_businesstab',
      contentId: 'platform_Myrewardpoints_businesstab',
      exposureTimes: 1,
      businessInfo: {},
    });

    this.getBasic();
    UBT.pageView({
      pageId: 'new_mybonus',
      categoryId: 'platform',
      businessInfo: {
        adsource: ParamsUtil.getParam('adsource'),
      },
    });
  },
  methods: {
    async getTabs() {
      const { token } = await getTokenAndKey();
      try {
        const res = await bountyExchangeTab({
          token,
        });
        if (res.data) {
          this.TABS = res.data;
        }
        // eslint-disable-next-line no-empty
      } catch {

      }
    },
    goDetail() {
      UBT.clickButton({
        pageId: 'platform_My_reward_points',
        buttonName: 'platform_details',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.clickButton({
        pageId: 'new_mybonus',
        buttonName: 'bonus_newdetailed',
        categoryId: 'platform',
        businessInfo: {},
      });
      // this.$router.push({
      //   path: '/bounty/record',
      //   query: { points: this.points },
      // });
      welfareGo(
        `https://m.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty/record?adsource=1&points=${this.points}`,
      );
    },
    async getBasic() {
      const { token } = await getTokenAndKey();
      const basic = await getBountyBasicInfo({ token, pointType: 1 })
        .then((v) => v.data || {}).catch(() => ({}));
      this.amount = basic.amount || 0;
      this.expiring = basic.expiring || 0;
      this.points = basic.points || 0;
    },
    goRule() {
      UBT.clickButton({
        pageId: 'platform_My_reward_points',
        buttonName: 'platform_myrewardpoint_rules',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.clickButton({
        pageId: 'new_mybonus',
        buttonName: 'bonus_rule',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location.href = 'https://m.hellobike.com/mf/spa/u_ejpsym/latest/MA2203112923159586536947712.html?activityCode=MA2203112923159586536947712';
    },
    // 判断页面广告支持情况
    async judgePageAdSupport() {
      // 非App端 => 不支持广告
      if (!this.isApp) {
        this.isSupportAd = false;
        return;
      }
      // App端 => 版本必须要满足6.88.5及以上
      try {
        const version = await getVersion();
        const isSupport = compareVersions(version, '6.88.5') !== -1;
        this.isSupportAd = isSupport;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('judgePageAdSupport => error', safeJsonStringify(error));
      }
    },
    onListLoaded() {
      // 列表加载完成回调，可扩展
    },
    onExchangeSuccess() {
      this.$emit('success');
    },
  },
};
</script>

<style lang="less" scoped>
.welfare-exchange-container {
  min-height: 100%;
  font-size: 20px;
  display: flex;
  flex-direction: column;

  .body {
    flex: 1;
    background: #f0f3f5;
    border-radius: 0.12rem 0.12rem 0 0;
  }

  .header {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-top: 0.18rem;
    height: 1.66rem;
    margin-bottom: -0.16rem;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/SSsBOFX8P-JIGvYMF91M0.png);
    background-size: 100% 100%;

    .line-1 {
      font-size: 0.12rem;
      color: #fff;
      opacity: 0.72;
      margin-bottom: 0.04rem;
    }

    .line-3 {
      font-size: 0.12rem;
      font-weight: 500;
      margin-top: 0.08rem;
      color: rgba(255, 255, 255, 1);

      .tag {
        height: 0.14rem;
        padding: 2px 4px;
        background: rgba(255, 255, 255, 0.19);
        border-radius: 0.06rem;
        margin: 0 2px;
        font-family: "DIN Alternate Bold", sans-serif;
      }
    }

    .operation {
      display: flex;
      margin-top: 0.08rem;

      .btn {
        margin: 0 0.11rem;
        height: 0.23rem;
        border-radius: 0.12rem;
        border: 1px solid rgba(253, 254, 254, 0.47);
        font-size: 0.12rem;
        color: #fff;
        padding: 0 0.08rem;
      }
    }

    .bounty {
      display: flex;
      position: relative;
      align-items: flex-end;

      .amount {
        font-size: 0.38rem;
        font-family: "DIN Alternate Bold", sans-serif;
        font-weight: bold;
        color: #fff;
        line-height: 1;
        text-shadow: 0 0 0 rgba(47, 120, 222, 0.69);
      }

      .unit {
        font-size: 0.12rem;
        color: #fffce8;
        padding-bottom: 0.06rem;
        padding-left: 0.02rem;
      }

      .hint {
        position: absolute;
        bottom: 0.06rem;
        right: 0;
        transform: translateX(104%);
        height: 0.16rem;
        background: #fbe57f;
        white-space: nowrap;
        padding: 1px 6px;
        box-shadow: 0 0.01rem 0.01rem 0 #3483e4;
        border-radius: 0.08rem;
        font-size: 0.12rem;
        color: #ae6300;
      }
    }
  }
}
</style>
